import {
  request
} from '../utils/http'

/**
 * @function 查询门店信息
 * @param params 
 * @returns 
 */
export const getWxMinaStoreInfoServer = params => request({
  url: 'openapi.hardware.device.belong.query.store.info',
  data: {
    ...params
  }
})

/**
 * @function 创建订单
 * @param params 
 * @returns 
 */
export const createWxMinaOrderServer = params => request({
  url: 'fbpay.order.create',
  data: {
    ...params
  },
  retryTimes: 1
})

/**
 * @function 查询订单
 * @param params 
 * @returns 
 */
export const getWxMinaOrderInfoServer = params => request({
  url: 'fbpay.order.query',
  data: {
    ...params
  }
})

/**
 * @function 订单关闭
 * @param params 
 * @returns 
 */
export const closeWxMinaOrderServer = params => request({
  url: 'fbpay.order.close',
  data: {
    ...params
  },
  retryTimes: 1
})
